import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-outward",
  "use": "arrow-outward-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-outward\"><path d=\"M15 1h-4.5s-.5 0-.5.5.498.502.5.5h2.785L8.8 6.485l.707.707L14 2.7v2.805c.004.056.033.495.5.495.5 0 .501-.502.5-.501V1zM5.5 15H1v-4.5c-.001.002 0-.5.5-.5.467 0 .496.439.5.495v2.79L6.285 9l.707.707L2.7 14.001h2.8c.003-.003.5 0 .5.5s-.5.5-.5.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol